import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogContent, Grid, Typography } from '@mui/material';

import { themeObject } from 'lib';
interface SystemWalletTypeDialogProps {
    openDialog: boolean;
    handleCloseDialog: () => void;
    handleChangeType: () => void;
}

const systemWalletTypeDialogStyles = {
    dialog: {
        '& .MuiPaper-root': {
            width: '462px',
            height: '288px',
            '& .MuiDialogContent-root': {
                p: '8px 34.5px 37px 34.5px',
                overflow: 'hidden',
            },
        },
    },
    buttonContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mt: 2.5,
    },
    textStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
};

export const SystemWalletTypeDialog = ({
    openDialog,
    handleCloseDialog,
    handleChangeType,
}: SystemWalletTypeDialogProps): React.JSX.Element => {
    return (
        <Dialog
            closable={true}
            open={openDialog}
            onClose={handleCloseDialog}
            title={'Change System Wallet Type'}
            sx={systemWalletTypeDialogStyles.dialog}
        >
            <DialogContent>
                <Grid>
                    <Typography sx={systemWalletTypeDialogStyles.textStyles}>
                        If you change the system wallet type, any existing SDOs
                        will remain associated with the old type, while all
                        future SDOs will follow the new type.
                    </Typography>
                </Grid>
                <Grid sx={systemWalletTypeDialogStyles.buttonContainerStyles}>
                    <Button
                        size='large'
                        color='primary'
                        onClick={handleChangeType}
                    >
                        Yes, change type
                    </Button>
                    <Button
                        size='large'
                        variant='text'
                        onClick={handleCloseDialog}
                    >
                        Cancel
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
